/* DK Buy Now - injects Buy Now button on product pages (desktop + mobile sticky bar) */
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var addBtn = document.querySelector('.dk-pdp__add-btn');
    if(!addBtn || addBtn.disabled) return;

    var form = addBtn.closest('form');
    if(!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if(!variantInput) return;

    function handleBuyNow(btn){
      btn.textContent = 'LOADING...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items:[{id: parseInt(variantInput.value), quantity: 1}]})
      }).then(function(){
        window.location.href = '/checkout';
      }).catch(function(){
        btn.textContent = 'BUY NOW';
        btn.disabled = false;
      });
    }

    /* Desktop: inject after the form in dk-pdp__bottom */
    var buyBtn = document.createElement('button');
    buyBtn.type = 'button';
    buyBtn.className = 'dk-pdp__buy-btn';
    buyBtn.textContent = 'BUY NOW';
    form.parentNode.insertBefore(buyBtn, form.nextSibling);
    buyBtn.addEventListener('click', function(){ handleBuyNow(buyBtn); });

    /* Mobile: inject into sticky bar after the ADD TO CART button */
    var stickyBar = document.getElementById('dk-sticky-bar');
    var stickyAtc = document.getElementById('dk-sticky-atc');
    if(stickyBar && stickyAtc && !stickyAtc.disabled){
      var stickyBuy = document.createElement('button');
      stickyBuy.type = 'button';
      stickyBuy.className = 'dk-pdp__sticky-btn dk-pdp__sticky-buy';
      stickyBuy.textContent = 'BUY NOW';
      stickyBuy.style.background = 'transparent';
      stickyBuy.style.color = '#5CE1E6';
      stickyBuy.style.borderColor = '#5CE1E6';
      stickyAtc.parentNode.insertBefore(stickyBuy, stickyAtc.nextSibling);
      stickyBuy.addEventListener('click', function(){ handleBuyNow(stickyBuy); });
    }
  });
})();

/* DK Gallery Preload - preloads all product gallery images in the background
   so thumbnail clicks are instant (image already in browser cache) */
(function(){
  var container = document.getElementById('dk-thumbs');
  if(!container) return;

  function preloadGallery(){
    container.querySelectorAll('.dk-pdp__thumb[data-type="image"]').forEach(function(t){
      var src = t.getAttribute('data-src');
      if(src){ var p = new Image(); p.src = src; }
      var full = t.getAttribute('data-full');
      if(full){ var p2 = new Image(); p2.src = full; }
    });
  }

  /* Wait until browser is idle so we don't compete with critical resources */
  if('requestIdleCallback' in window){
    requestIdleCallback(preloadGallery);
  } else {
    setTimeout(preloadGallery, 1000);
  }
})();
